module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-cases-filter u-fixed u-pos-tl u-flex u-flex-jc--center u-fit-v u-bg--white-near u-overflow-h",
    class: [_vm.isActive ? 'is-active' : ''],
    style: ({
      'transform': 'translateY(' + _vm.$root.smoothScroll + 'px) translateZ(0)'
    }),
    on: {
      "touchstart": _vm.onTouchDown,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd
    }
  }, [_c('div', {
    staticClass: "c-cases-filter__close u-absolute u-force-3d u-zindex--3 u-click-are-xs u-cursor-pointer u-click-area-xxs",
    on: {
      "click": function($event) {
        _vm._onClickOnContainer('button')
      }
    }
  }, [_c('span', {
    staticClass: "t-text--xxs t-fweight--bold u-uppercase"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "c-cases-filter__container js-filters-container u-relative u-zindex--2 u-fit-w",
    class: [_vm.filtersItemsTotalHeight > (_vm.$root.height - (70 * 2)) ? 'u-inline-block' : 'u-flex u-flex-fd--column u-flex-jc--center'],
    on: {
      "click": function($event) {
        _vm._onClickOnContainer('background')
      }
    }
  }, [_c('div', {
    staticClass: "c-cases-filter__category c-cases-filter__category--first js-filters-item u-force-3d",
    class: [_vm.filter === null ? 'is-active' : ''],
    on: {
      "click": function($event) {
        _vm._resetFilters()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.categories), function(category, index) {
    return _c('div', {
      staticClass: "c-cases-filter__category js-filters-item u-force-3d",
      class: [_vm.filter === category.title_slug ? 'is-active' : ''],
      on: {
        "click": function($event) {
          _vm._toggleCategoryOnFilter(category.title_slug)
        }
      }
    }, [_c('div', {
      staticClass: "c-cases-filter__category__wrapper u-force-3d u-inline-block u-overflow-h u-cursor-pointer"
    }, [_c('span', {
      staticClass: "u-force-3d t-text--xxl t-ffamily--freight u-uppercase",
      domProps: {
        "innerHTML": _vm._s(category.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-cases-filter__category__mask u-absolute u-pos-tl u-overflow-h"
    }, [_c('div', {
      staticClass: "c-cases-filter__category__mask__text u-relative t-text--xxl t-ffamily--freight u-color--black u-uppercase",
      domProps: {
        "innerHTML": _vm._s(category.title)
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-cases-filter__category js-filters-item u-force-3d",
    class: [_vm.filter === 'all' ? 'is-active' : ''],
    on: {
      "click": function($event) {
        _vm._getAllFilters()
      }
    }
  }, [_vm._m(1)])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-cases-filter__category__wrapper u-force-3d u-inline-block u-overflow-h u-cursor-pointer"
  }, [_c('span', {
    staticClass: "u-force-3d t-text--xxl t-ffamily--freight u-uppercase"
  }, [_vm._v("Featured Projects")]), _vm._v(" "), _c('div', {
    staticClass: "c-cases-filter__category__mask u-absolute u-pos-tl u-overflow-h"
  }, [_c('div', {
    staticClass: "c-cases-filter__category__mask__text u-relative t-text--xxl t-ffamily--freight u-color--black u-uppercase"
  }, [_vm._v("Featured Projects")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-cases-filter__category__wrapper u-force-3d u-inline-block u-overflow-h u-cursor-pointer"
  }, [_c('span', {
    staticClass: "u-force-3d t-text--xxl t-ffamily--freight u-uppercase"
  }, [_vm._v("All Projects")]), _vm._v(" "), _c('div', {
    staticClass: "c-cases-filter__category__mask u-absolute u-pos-tl u-overflow-h"
  }, [_c('div', {
    staticClass: "c-cases-filter__category__mask__text u-relative t-text--xxl t-ffamily--freight u-color--black u-uppercase"
  }, [_vm._v("All Projects")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaeb76d4"}!./src/scripts/components/app-cases-filter/template.html
// module id = 146
// module chunks = 0